import Request from './Request';

export default class OrbitArtifactsService {
    static async list(params = {}) {
        const qs = new URLSearchParams(
            Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        ).toString();
        return Request.get(`/api/orbit/artifacts${qs ? '?' + qs : ''}`);
    }

    static async create(data) {
        return Request.post('/api/orbit/artifacts', data);
    }

    static async update(id, data) {
        return Request.post(`/api/orbit/artifacts/${id}`, data);
    }

    static async delete(id) {
        return Request._delete(`/api/orbit/artifacts/${id}`);
    }
}

